// @flow
import * as React from 'react';
import Radium from 'radium';

import {
  Card,
  CardHeader,
  CardBlock,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import { Colors, Spacing } from 'utils/styleguide';

type Props = {
  title: string,
  responses: Array<string>,
  statusComponent?: React.Node,
};

class SurveyResultOpen extends React.PureComponent<Props> {
  render() {
    const { title, responses, statusComponent } = this.props;
    const responsesCount = responses.length;

    return (
      <Card style={styles.root}>
        <CardHeader style={styles.title}>
          <span>
            {title} {!!statusComponent ? statusComponent : ''}
          </span>
          <span>
            {responsesCount} Antwort{responsesCount !== 1 ? 'en' : ''}
          </span>
        </CardHeader>
        <CardBlock>
          <ListGroup>
            {responses.map(response => {
              return <ListGroupItem key={response}>{response}</ListGroupItem>;
            })}
          </ListGroup>
        </CardBlock>
      </Card>
    );
  }
}

const styles = {
  root: {
    width: '100%',
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
  },
  answer: {
    marginBottom: Spacing.Nano,
  },
  bar: {
    height: 4,
    width: '100%',
  },
  innerBar: {
    height: 4,
  },
  responsesCount: {
    color: Colors.LightGrey,
    marginLeft: Spacing.Nano,
  },
  description: {
    color: Colors.LightGrey,
  },
};

export default Radium(SurveyResultOpen);



// WEBPACK FOOTER //
// ./src/components/SurveyResult/SurveyResultOpen.js